<div class="w-full flex flex-col" style="height: 100%; max-height: 100%; overflow: hidden;">
    <div class="flex items-start justify-between mb-4 flex-shrink-0">
        <div>
            <p class="text-sm md:text-xl font-semibold text-mg-main-blue-dark tracking-tight m-0">Guía de Regularización de Marcas</p>
            <p class="text-xs md:text-md text-mg-gray mt-0.5 m-0">Aprende cómo corregir y completar tus marcaciones de forma sencilla</p>
        </div>
        <button (click)="volver.emit()"
            class="border border-mg-main-blue text-mg-main-blue rounded-xl text-sm flex items-center justify-center flex-shrink-0 ml-2 px-4 py-2 gap-1.5">
            <mg-icon iconName="arrow_back" iconClass="text-base text-mg-main-blue leading-none"></mg-icon>
            Volver
        </button>
    </div>
    <div
        style="flex: 1 1 0%; min-height: 0; overflow-y: auto; background: white; border-radius: 0.75rem; border: 1px solid var(--mg-main-blue-light, #e0e7ff);">
        <mat-accordion>
            @for (section of sections; track section.title) {
            <mat-expansion-panel
                class="!shadow-none !rounded-none !border-b !border-mg-main-blue-light last:!border-b-0 !m-0">
                <mat-expansion-panel-header class="!py-4 !px-5 hover:!bg-gray-50">
                    <mat-panel-title class="text-md text-mg-main-blue-dark font-medium">
                        {{ section.title }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="px-5 pb-4">
                    @if (section.hasIcons) {
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                        @for (item of section.items; track item.label) {
                        <div class="flex items-center gap-2.5">
                            <div class="flex items-center justify-center rounded-full w-7 h-7 flex-shrink-0"
                                [class]="item.badgeClass">
                                <mg-icon [iconName]="item.icon!" iconClass="leading-none text-sm"></mg-icon>
                            </div>
                            <span class="text-[12px] text-mg-gray">{{ item.label }}</span>
                        </div>
                        }
                    </div>
                    } @else if (section.hasChecks) {
                    <div class="flex flex-col gap-2.5">
                        @for (item of section.items; track item.label) {
                        <div class="flex items-center gap-2.5">
                            <div
                                class="flex items-center justify-center bg-mg-green-light border border-mg-green-dark rounded-full w-5 h-5 flex-shrink-0">
                                <mg-icon iconName="check" iconClass="text-mg-green-dark leading-none text-xs"></mg-icon>
                            </div>
                            <span class="text-[12px] text-mg-gray leading-snug">{{ item.label }}</span>
                        </div>
                        }
                    </div>
                    } @else {
                    <div class="flex flex-col gap-2.5">
                        @for (item of section.items; track item.label) {
                        <div class="flex items-center gap-3">
                            <span class="text-[12px] font-semibold py-1 rounded-lg flex-shrink-0 text-center w-20"
                                [class]="item.badgeClass">
                                {{ item.label }}
                            </span>
                            <span class="text-[12px] text-mg-gray leading-snug">{{ item.description }}</span>
                        </div>
                        }
                    </div>
                    }
                </div>
            </mat-expansion-panel>
            }
        </mat-accordion>
    </div>
</div>